import React from "react";
import styles from "./Text.module.scss";
import classnames from "classnames";

/**
 * old HTML element was forcing the tagname to be specific tag like h1,h2,h3,h4,h5,h6,p - so we were rendering this tag and the content inside it
 * new HTML element enable the user to select his prefer tag, so we are gonna render his tag inside a wrapper div
 * could be deleted after 1 year
 */

export function fallBackTag(value, tag) {
  const isNew = value?.startsWith("<h") || value?.startsWith("<p");
  return isNew ? "div" : tag;
}

const HTMLText = ({ tag, className, value, style }) => {
  const Tag = fallBackTag(value, tag);

  return (
    <Tag
      style={style}
      className={classnames(styles.text, className)}
      dangerouslySetInnerHTML={{ __html: value ?? "" }}
    />
  );
};

export default HTMLText;
